export default {
	namespace: 'home',
	beforeEnter() {

	},
	afterEnter( data ){
		console.log('View: home')

		const thumbers	= data.next.container.querySelectorAll('.home--clients .client')
		const thumb		= data.next.container.querySelector('.background .thumb')

		const observer = new IntersectionObserver(entries => {

			entries.forEach(entry => {
				if( document.documentElement.classList.contains('aos-loading') ){ return }

				entry.target.classList.toggle('active', entry.isIntersecting)

				if( entry.isIntersecting ){
					thumb.style.backgroundImage = 'url('+ entry.target.querySelector('link').href +')'
				}
			})

			let active = window.scrollY < window.innerHeight / 2

			thumbers.forEach(el => {
				active ||= el.classList.contains('active')
			})

			thumb.classList.toggle('active', active)

		}, { rootMargin: '-50% 0% -50% 0%' })

		thumbers.forEach(el => {
			observer.observe(el)
		})

	},
	beforeLeave() {

	},
	afterLeave() {

	}
}
